import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton } from '@mui/material';
import { FC } from 'react';

interface BundlePromoContentRecommendationProps {
	partNumber: string;
}

const NullElement = () => null;

export const BundlePromoContentRecommendation: FC<BundlePromoContentRecommendationProps> = ({
	partNumber,
}) => {
	const emsName = `DPSV2Bundle_${partNumber}_Promotion`;
	return (
		<ContentRecommendation
			id={emsName}
			properties={{ emsName }}
			withoutFrame
			loadingElement={<Skeleton variant="rectangular" height="35px" width="100%" />}
			emptyElement={<NullElement />}
		/>
	);
};
